import { useState, FormEvent } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Logo } from '../components/Logo';

export const LoginPage = () => {
  const { user, login, isLoggingIn } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    login({ username, password });
  };

  if (user) {
    const target =
      user.role === 'SUPER_ADMIN' ? '/superadmin' : user.role === 'UNIT_ADMIN' ? '/admin' : '/recorder';
    return <Navigate to={target} replace />;
  }

  return (
    <>
      <Helmet>
        <title>Přihlášení — Soutěže | HasičiOnline.cz</title>
      </Helmet>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #FAFAFA 0%, #F5F5F5 100%)',
        }}
      >
        <Container maxWidth="sm">
          <Stack spacing={4} alignItems="center">
            <Logo size={72} variant="mark" />
            <Card sx={{ width: '100%', boxShadow: 4, borderRadius: 2 }}>
              <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
                <Stack spacing={3}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h4" fontWeight={700} gutterBottom>
                      Přihlášení
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Administrace soutěží
                    </Typography>
                  </Box>

                  <Box component="form" onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                      <TextField
                        label="Uživatelské jméno nebo e-mail"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoFocus
                        fullWidth
                        required
                        autoComplete="username"
                      />
                      <TextField
                        label="Heslo"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        fullWidth
                        required
                        autoComplete="current-password"
                      />
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={isLoggingIn || !username || !password}
                        sx={{ py: 1.5 }}
                      >
                        {isLoggingIn ? 'Přihlašuji…' : 'Přihlásit se'}
                      </Button>
                      <Box sx={{ textAlign: 'center' }}>
                        <Button component="a" href="/forgot-password" size="small" variant="text">
                          Zapomenuté heslo?
                        </Button>
                      </Box>
                    </Stack>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
            <Typography variant="caption" color="text.secondary">
              © {new Date().getFullYear()} HasičiOnline.cz
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};
